import React, { useState } from 'react';
import { Modal, Pressable, Text, View } from 'react-native';

export type OverflowMenuItem = {
  key: string;
  label: string;
  onPress: () => void;
  destructive?: boolean;
};

type Props = {
  items: OverflowMenuItem[];
  /** Varsayılan: dikey üç nokta */
  size?: 'md' | 'sm';
  accessibilityLabel?: string;
};

export function OverflowMenu({ items, size = 'md', accessibilityLabel = 'Daha fazla' }: Props) {
  const [open, setOpen] = useState(false);
  const dotClass = size === 'sm' ? 'text-xl leading-none' : 'text-2xl leading-none';

  if (items.length === 0) {
    return null;
  }

  return (
    <>
      <Pressable
        onPress={() => setOpen(true)}
        hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
        className="rounded-lg px-1.5 py-0.5 active:opacity-70"
        accessibilityRole="button"
        accessibilityLabel={accessibilityLabel}>
        <Text className={`${dotClass} font-bold tracking-widest text-zinc-600 dark:text-zinc-300`}>
          ⋯
        </Text>
      </Pressable>
      <Modal visible={open} transparent animationType="fade" onRequestClose={() => setOpen(false)}>
        <Pressable
          className="flex-1 justify-center bg-black/45 px-5"
          onPress={() => setOpen(false)}
          accessibilityViewIsModal>
          <Pressable
            onPress={e => e.stopPropagation()}
            className="w-full max-w-sm self-center overflow-hidden rounded-2xl border border-zinc-200 bg-white dark:border-zinc-700 dark:bg-zinc-900">
            {items.map((it, idx) => (
              <Pressable
                key={it.key}
                onPress={() => {
                  setOpen(false);
                  // İç içe Modal (menü + şikayet sheet) aynı karede açılınca iOS’ta ikinci modal görünmeyebilir.
                  setTimeout(() => {
                    it.onPress();
                  }, 220);
                }}
                className={`px-4 py-4 active:bg-zinc-50 dark:active:bg-zinc-800 ${
                  idx < items.length - 1 ? 'border-b border-zinc-100 dark:border-zinc-800' : ''
                }`}>
                <Text
                  className={`text-center text-base font-semibold ${
                    it.destructive
                      ? 'text-rose-600 dark:text-rose-400'
                      : 'text-zinc-900 dark:text-zinc-100'
                  }`}>
                  {it.label}
                </Text>
              </Pressable>
            ))}
            <Pressable
              onPress={() => setOpen(false)}
              className="border-t border-zinc-200 bg-zinc-50 px-4 py-3.5 dark:border-zinc-800 dark:bg-zinc-950">
              <Text className="text-center text-sm font-semibold text-zinc-500 dark:text-zinc-400">
                Vazgeç
              </Text>
            </Pressable>
          </Pressable>
        </Pressable>
      </Modal>
    </>
  );
}
